/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateUserPersonalDataRequestWithAreaOfInterestDto } from '../models';
// @ts-ignore
import type { SetPreferredLanguageRequestDto } from '../models';
// @ts-ignore
import type { UpdateUserPersonalDataRequestWithAreaOfInterestsDto } from '../models';
// @ts-ignore
import type { UserDetailsDto } from '../models';
// @ts-ignore
import type { UserPersonalDataWithAreaOfInterestsDto } from '../models';
/**
 * RestUserApi - axios parameter creator
 * @export
 */
export const RestUserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create user personal data
         * @param {string} userId 
         * @param {CreateUserPersonalDataRequestWithAreaOfInterestDto} createUserPersonalDataRequestWithAreaOfInterestDto User personal data request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserPersonalData: async (userId: string, createUserPersonalDataRequestWithAreaOfInterestDto: CreateUserPersonalDataRequestWithAreaOfInterestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('createUserPersonalData', 'userId', userId)
            // verify required parameter 'createUserPersonalDataRequestWithAreaOfInterestDto' is not null or undefined
            assertParamExists('createUserPersonalData', 'createUserPersonalDataRequestWithAreaOfInterestDto', createUserPersonalDataRequestWithAreaOfInterestDto)
            const localVarPath = `/api/users/{userId}/personal-data`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserPersonalDataRequestWithAreaOfInterestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user details
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser: async (email?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user personal data
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPersonalData: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserPersonalData', 'userId', userId)
            const localVarPath = `/api/users/{userId}/personal-data`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set preferred language of the user (used e.g. for emails)
         * @param {string} userId 
         * @param {SetPreferredLanguageRequestDto} setPreferredLanguageRequestDto Preferred language request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserPreferredLanguage: async (userId: string, setPreferredLanguageRequestDto: SetPreferredLanguageRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('setUserPreferredLanguage', 'userId', userId)
            // verify required parameter 'setPreferredLanguageRequestDto' is not null or undefined
            assertParamExists('setUserPreferredLanguage', 'setPreferredLanguageRequestDto', setPreferredLanguageRequestDto)
            const localVarPath = `/api/users/{userId}/language`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setPreferredLanguageRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update user personal data
         * @param {string} userId 
         * @param {UpdateUserPersonalDataRequestWithAreaOfInterestsDto} updateUserPersonalDataRequestWithAreaOfInterestsDto User personal data request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPersonalData: async (userId: string, updateUserPersonalDataRequestWithAreaOfInterestsDto: UpdateUserPersonalDataRequestWithAreaOfInterestsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserPersonalData', 'userId', userId)
            // verify required parameter 'updateUserPersonalDataRequestWithAreaOfInterestsDto' is not null or undefined
            assertParamExists('updateUserPersonalData', 'updateUserPersonalDataRequestWithAreaOfInterestsDto', updateUserPersonalDataRequestWithAreaOfInterestsDto)
            const localVarPath = `/api/users/{userId}/personal-data`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserPersonalDataRequestWithAreaOfInterestsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestUserApi - functional programming interface
 * @export
 */
export const RestUserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestUserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create user personal data
         * @param {string} userId 
         * @param {CreateUserPersonalDataRequestWithAreaOfInterestDto} createUserPersonalDataRequestWithAreaOfInterestDto User personal data request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUserPersonalData(userId: string, createUserPersonalDataRequestWithAreaOfInterestDto: CreateUserPersonalDataRequestWithAreaOfInterestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUserPersonalData(userId, createUserPersonalDataRequestWithAreaOfInterestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestUserApi.createUserPersonalData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get user details
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentUser(email?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentUser(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestUserApi.getCurrentUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get user personal data
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserPersonalData(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserPersonalDataWithAreaOfInterestsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserPersonalData(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestUserApi.getUserPersonalData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set preferred language of the user (used e.g. for emails)
         * @param {string} userId 
         * @param {SetPreferredLanguageRequestDto} setPreferredLanguageRequestDto Preferred language request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setUserPreferredLanguage(userId: string, setPreferredLanguageRequestDto: SetPreferredLanguageRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setUserPreferredLanguage(userId, setPreferredLanguageRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestUserApi.setUserPreferredLanguage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update user personal data
         * @param {string} userId 
         * @param {UpdateUserPersonalDataRequestWithAreaOfInterestsDto} updateUserPersonalDataRequestWithAreaOfInterestsDto User personal data request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserPersonalData(userId: string, updateUserPersonalDataRequestWithAreaOfInterestsDto: UpdateUserPersonalDataRequestWithAreaOfInterestsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserPersonalData(userId, updateUserPersonalDataRequestWithAreaOfInterestsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestUserApi.updateUserPersonalData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestUserApi - factory interface
 * @export
 */
export const RestUserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestUserApiFp(configuration)
    return {
        /**
         * 
         * @summary Create user personal data
         * @param {string} userId 
         * @param {CreateUserPersonalDataRequestWithAreaOfInterestDto} createUserPersonalDataRequestWithAreaOfInterestDto User personal data request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserPersonalData(userId: string, createUserPersonalDataRequestWithAreaOfInterestDto: CreateUserPersonalDataRequestWithAreaOfInterestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createUserPersonalData(userId, createUserPersonalDataRequestWithAreaOfInterestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user details
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser(email?: string, options?: RawAxiosRequestConfig): AxiosPromise<UserDetailsDto> {
            return localVarFp.getCurrentUser(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user personal data
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPersonalData(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserPersonalDataWithAreaOfInterestsDto> {
            return localVarFp.getUserPersonalData(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set preferred language of the user (used e.g. for emails)
         * @param {string} userId 
         * @param {SetPreferredLanguageRequestDto} setPreferredLanguageRequestDto Preferred language request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserPreferredLanguage(userId: string, setPreferredLanguageRequestDto: SetPreferredLanguageRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setUserPreferredLanguage(userId, setPreferredLanguageRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update user personal data
         * @param {string} userId 
         * @param {UpdateUserPersonalDataRequestWithAreaOfInterestsDto} updateUserPersonalDataRequestWithAreaOfInterestsDto User personal data request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPersonalData(userId: string, updateUserPersonalDataRequestWithAreaOfInterestsDto: UpdateUserPersonalDataRequestWithAreaOfInterestsDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateUserPersonalData(userId, updateUserPersonalDataRequestWithAreaOfInterestsDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestUserApi - interface
 * @export
 * @interface RestUserApi
 */
export interface RestUserApiInterface {
    /**
     * 
     * @summary Create user personal data
     * @param {string} userId 
     * @param {CreateUserPersonalDataRequestWithAreaOfInterestDto} createUserPersonalDataRequestWithAreaOfInterestDto User personal data request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUserApiInterface
     */
    createUserPersonalData(userId: string, createUserPersonalDataRequestWithAreaOfInterestDto: CreateUserPersonalDataRequestWithAreaOfInterestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get user details
     * @param {string} [email] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUserApiInterface
     */
    getCurrentUser(email?: string, options?: RawAxiosRequestConfig): AxiosPromise<UserDetailsDto>;

    /**
     * 
     * @summary Get user personal data
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUserApiInterface
     */
    getUserPersonalData(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserPersonalDataWithAreaOfInterestsDto>;

    /**
     * 
     * @summary Set preferred language of the user (used e.g. for emails)
     * @param {string} userId 
     * @param {SetPreferredLanguageRequestDto} setPreferredLanguageRequestDto Preferred language request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUserApiInterface
     */
    setUserPreferredLanguage(userId: string, setPreferredLanguageRequestDto: SetPreferredLanguageRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Update user personal data
     * @param {string} userId 
     * @param {UpdateUserPersonalDataRequestWithAreaOfInterestsDto} updateUserPersonalDataRequestWithAreaOfInterestsDto User personal data request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUserApiInterface
     */
    updateUserPersonalData(userId: string, updateUserPersonalDataRequestWithAreaOfInterestsDto: UpdateUserPersonalDataRequestWithAreaOfInterestsDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestUserApi - object-oriented interface
 * @export
 * @class RestUserApi
 * @extends {BaseAPI}
 */
export class RestUserApi extends BaseAPI implements RestUserApiInterface {
    /**
     * 
     * @summary Create user personal data
     * @param {string} userId 
     * @param {CreateUserPersonalDataRequestWithAreaOfInterestDto} createUserPersonalDataRequestWithAreaOfInterestDto User personal data request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUserApi
     */
    public createUserPersonalData(userId: string, createUserPersonalDataRequestWithAreaOfInterestDto: CreateUserPersonalDataRequestWithAreaOfInterestDto, options?: RawAxiosRequestConfig) {
        return RestUserApiFp(this.configuration).createUserPersonalData(userId, createUserPersonalDataRequestWithAreaOfInterestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user details
     * @param {string} [email] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUserApi
     */
    public getCurrentUser(email?: string, options?: RawAxiosRequestConfig) {
        return RestUserApiFp(this.configuration).getCurrentUser(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user personal data
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUserApi
     */
    public getUserPersonalData(userId: string, options?: RawAxiosRequestConfig) {
        return RestUserApiFp(this.configuration).getUserPersonalData(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set preferred language of the user (used e.g. for emails)
     * @param {string} userId 
     * @param {SetPreferredLanguageRequestDto} setPreferredLanguageRequestDto Preferred language request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUserApi
     */
    public setUserPreferredLanguage(userId: string, setPreferredLanguageRequestDto: SetPreferredLanguageRequestDto, options?: RawAxiosRequestConfig) {
        return RestUserApiFp(this.configuration).setUserPreferredLanguage(userId, setPreferredLanguageRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update user personal data
     * @param {string} userId 
     * @param {UpdateUserPersonalDataRequestWithAreaOfInterestsDto} updateUserPersonalDataRequestWithAreaOfInterestsDto User personal data request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUserApi
     */
    public updateUserPersonalData(userId: string, updateUserPersonalDataRequestWithAreaOfInterestsDto: UpdateUserPersonalDataRequestWithAreaOfInterestsDto, options?: RawAxiosRequestConfig) {
        return RestUserApiFp(this.configuration).updateUserPersonalData(userId, updateUserPersonalDataRequestWithAreaOfInterestsDto, options).then((request) => request(this.axios, this.basePath));
    }
}

